import { fmtDT } from "@/constants";

export const PERIODS = [["7", "7 jours"], ["28", "28 jours"], ["90", "3 mois"], ["180", "6 mois"], ["365", "12 mois"]];

export const fmtN = (n) => new Intl.NumberFormat("fr-FR").format(n ?? 0);
export const pct = (v) => (v == null ? "—" : `${v > 0 ? "+" : ""}${v} %`);
export const evoCls = (v, invert = false) => {
  if (v == null) return "text-slate-400";
  const good = invert ? v < 0 : v > 0;
  return v === 0 ? "text-slate-400" : good ? "text-emerald-600" : "text-rose-600";
};

export function PeriodTabs({ value, onChange }) {
  return (
    <div className="flex gap-1.5 flex-wrap" data-testid="seo-period-tabs">
      {PERIODS.map(([k, label]) => (
        <button key={k} data-testid={`seo-period-${k}`} onClick={() => onChange(k)}
          className={`rounded-full px-3 py-1.5 text-xs font-semibold transition-colors ${value === k ? "bg-sky-600 text-white" : "bg-white border border-slate-200 text-slate-600"}`}>
          {label}
        </button>
      ))}
    </div>
  );
}

export function NotConnected({ goParams }) {
  return (
    <div className="rounded-2xl border border-amber-300 bg-amber-50 p-5 space-y-2" data-testid="seo-not-connected">
      <p className="font-heading font-bold text-amber-900">Google Search Console n'est pas connecté</p>
      <p className="text-sm text-amber-800">Connectez votre compte Google (lecture seule) pour voir les vraies statistiques de photobooth54.fr : clics, impressions, positions et mots-clés.</p>
      {goParams && (
        <button data-testid="seo-goto-params" onClick={goParams}
          className="rounded-xl bg-slate-900 text-white font-bold text-sm px-4 py-2.5">
          Connecter dans Paramètres →
        </button>
      )}
    </div>
  );
}

export function Freshness({ lastSync }) {
  return (
    <p className="text-xs text-slate-400" data-testid="seo-freshness">
      Données synchronisées {lastSync ? `le ${fmtDT(lastSync)}` : "jamais"} — Google publie ses statistiques avec ~2 jours de décalage.
    </p>
  );
}
